import { useQuery, useQueryClient, useMutation } from "@tanstack/react-query";
import { getGames, createGame as createGameApi } from "services/apiGames";
import { toast } from "react-toastify";

export function useGames() {
  const {
    isLoading,
    data: games,
    error,
  } = useQuery({
    queryKey: ["games"],
    queryFn: getGames,
  });

  return { isLoading, error, games };
}

export function useCreateGame() {
  const queryClient = useQueryClient();

  const { mutate: createGame, isLoading: isCreating } = useMutation({
    mutationFn: createGameApi,
    onSuccess: (response) => {
      toast.success("New game successfully created");
      const game = response?.data;
      if (game?.radioSlug) {
        const url = `https://www.betaplay.ng/radiogames/${game.radioSlug}`;
        navigator.clipboard.writeText(url).then(() => {
          toast.info(`Radio link copied: ${url}`);
        });
      }
      queryClient.invalidateQueries({ queryKey: ["games"] });
    },
    onError: (err) => toast.error(err.message),
  });

  return { isCreating, createGame };
}
